import React from 'react';
import PropTypes from 'prop-types';
import { InputChip, Tooltip, Flex } from '@upsales/components';

const MultipleSelectedValue = ({ data, className, removeProps }) => {
	const OPTION_CLASSES = ['Select-value', className];

	const name = data?.data?.name;
	const email = data?.data?.email || data?.data?.data?.email;

	const isUpsalesUser =
		data?.data?.hasOwnProperty('role') && data?.data?.hasOwnProperty('active') && data?.data?.hasOwnProperty('crm');

	return (
		<Flex className={OPTION_CLASSES.join(' ')} space="mbs">
			<Tooltip title={Tools.$translate('mail.missingEmail')} disabled={!!email}>
				<InputChip
					title={name}
					focus={data?.data?.isInRemoveState}
					space="mrs"
					invalid={!email}
					type={isUpsalesUser ? 'default' : 'outline'}
					onHide={e => {
						e.stopPropagation();
						e.preventDefault();
						removeProps?.onClick();
					}}
				/>
			</Tooltip>
		</Flex>
	);
};

MultipleSelectedValue.propTypes = {
	className: PropTypes.string,
	data: PropTypes.object
};

export default MultipleSelectedValue;
